import React, { useContext } from "react";
import styles from "./ArticleCard.module.scss";
import PathContext from "../../context/path";
import StatesContext from "../../context/states";
import MobileContext from "../../context/mobile";
const ArticleCard = (props) => {
  const path = useContext(PathContext);
  const states = useContext(StatesContext);
  const isMobile = useContext(MobileContext);
  const { size } = props;
  const { image, title, desc, id, short_description } = props.data;
  const { openArticle, endpoint } = states;

  let wrapClass = `${styles.wrap}`;
  if (size !== undefined && styles[`wrap_${size}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${size}`]}`;
  }
  return (
    <>
      <div className={wrapClass} onClick={() => { if (size !== 'big') { openArticle(id); } }}>
        <div className={styles.info}>
          <div className={styles.title}>{title}</div>
          <div className={styles.desc}>{short_description}</div>
        </div>
        <div className={styles.footer}>
          <div className={styles.icon}>
            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.8832 0.164794C23.3761 -0.432355 25 0.667093 25 2.27497V18.2237C25 19.7292 24.0125 21.0564 22.5705 21.489L12.8265 24.4122C12.6135 24.4761 12.3865 24.4761 12.1735 24.4122L2.4295 21.489C0.987505 21.0564 0 19.7292 0 18.2237V2.27497C0 0.667094 1.62392 -0.432355 3.1168 0.164794L12.5 3.91808L21.8832 0.164794ZM11.3636 5.91133L2.27273 2.27497V18.2237C2.27273 18.7256 2.6019 19.168 3.08256 19.3122L11.3636 21.7965V5.91133ZM13.6364 21.7965L21.9174 19.3122C22.3981 19.168 22.7273 18.7256 22.7273 18.2237V2.27497L13.6364 5.91133V21.7965Z" fill="#003333" />
            </svg>

          </div>
          {
            size !== undefined && styles[`wrap_${size}`] !== undefined && size === 'big' ?
              <div className={styles.link} onClick={() => { openArticle(id) }}>Читать {!isMobile ? 'статью' : null}
                {!isMobile ?
                  <svg width="26" height="9" viewBox="0 0 26 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M25.8536 4.85355C26.0488 4.65829 26.0488 4.34171 25.8536 4.14645L22.6716 0.964466C22.4763 0.769204 22.1597 0.769204 21.9645 0.964466C21.7692 1.15973 21.7692 1.47631 21.9645 1.67157L24.7929 4.5L21.9645 7.32843C21.7692 7.52369 21.7692 7.84027 21.9645 8.03553C22.1597 8.2308 22.4763 8.2308 22.6716 8.03553L25.8536 4.85355ZM0 5H25.5V4H0V5Z" fill="white" />
                  </svg>
                  :
                  <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 14.5L7 8L1 1.5" stroke="white" strokeWidth="1.5" />
                  </svg>

                }
              </div>
              :
              null
          }
        </div>
        <div className={styles.bg}>
          <picture>
            <img src={`${endpoint}${image && image.url?image.url : ''}`}  alt="" />
          </picture>
        </div>
      </div>
    </>
  );

}

export default ArticleCard;
